export default "__VITE_ASSET__U6muqRGa8aHtq8t0c9wAzg__"